var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1589_889)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C10.7402 2.25 9.53204 2.75044 8.64124 3.64124C7.75044 4.53204 7.25 5.74022 7.25 7C7.25 8.25978 7.75044 9.46796 8.64124 10.3588C9.53204 11.2496 10.7402 11.75 12 11.75C13.2598 11.75 14.468 11.2496 15.3588 10.3588C16.2496 9.46796 16.75 8.25978 16.75 7C16.75 5.74022 16.2496 4.53204 15.3588 3.64124C14.468 2.75044 13.2598 2.25 12 2.25ZM9.7019 4.7019C10.3114 4.09241 11.138 3.75 12 3.75C12.862 3.75 13.6886 4.09241 14.2981 4.7019C14.9076 5.3114 15.25 6.13805 15.25 7C15.25 7.86195 14.9076 8.6886 14.2981 9.2981C13.6886 9.90759 12.862 10.25 12 10.25C11.138 10.25 10.3114 9.90759 9.7019 9.2981C9.09241 8.6886 8.75 7.86195 8.75 7C8.75 6.13805 9.09241 5.3114 9.7019 4.7019ZM7.7019 16.7019C8.3114 16.0924 9.13805 15.75 10 15.75H14C14.862 15.75 15.6886 16.0924 16.2981 16.7019C16.9076 17.3114 17.25 18.138 17.25 19V21C17.25 21.4142 17.5858 21.75 18 21.75C18.4142 21.75 18.75 21.4142 18.75 21V19C18.75 17.7402 18.2496 16.532 17.3588 15.6412C16.468 14.7504 15.2598 14.25 14 14.25H10C8.74022 14.25 7.53204 14.7504 6.64124 15.6412C5.75044 16.532 5.25 17.7402 5.25 19V21C5.25 21.4142 5.58579 21.75 6 21.75C6.41421 21.75 6.75 21.4142 6.75 21V19C6.75 18.138 7.09241 17.3114 7.7019 16.7019Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1589_889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.a4aee1c986e45bd18f93111b42da6aec.svg";
export { ForwardRef as ReactComponent };